import { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import axios from "axios";
import { Grid, withStyles } from "@material-ui/core";
import Card from "components/core/basic/Card";
import getURLPrefix from "utils/getUrlPrefix";
import store from "redux/store";
import { setProductIndentifier, setPerformanceMetric } from "redux/reducers/userReducer";
import { selectModules } from "redux/selectors/modules";
import { Button } from "../components/core/basic/Button";
import { successToast, errorToast } from "../utils/toasts";
import { Center, VStack } from "../../styled-system/jsx";
import { PageContainer } from "../components/core/basic/PageContainer";
import { css } from "../../styled-system/css";

const URL_PREFIX = getURLPrefix();

const useStyles = (theme) => ({
  preferenceContainer: {
    marginTop: theme.spacing(5),
  },
  preferenceTitle: {
    margin: "0px 0px",
    paddingLeft: theme.spacing(2),
    fontWeight: 700,
    [theme.breakpoints.down("xs")]: {
      padding: theme.spacing(0, 2, 2),
      textAlign: "center",
    },
  },
  preferenceDescriptionContainer: {
    margin: "0px 0px",
    height: "40px",
    paddingLeft: theme.spacing(3),
    display: "flex",
    [theme.breakpoints.down("xs")]: {
      padding: theme.spacing(1),
      marginBottom: theme.spacing(2),
    },
  },
  preferenceDescription: {
    marginLeft: theme.spacing(2),
    display: "flex",
    alignItems: "center",
    fontSize: "16px",
    [theme.breakpoints.down("xs")]: {
      padding: theme.spacing(1, 2),
      textAlign: "center",
      margin: "auto",
    },
  },
  checkboxContainer: {
    height: "40px",
    display: "flex",
    justifyContent: "center",
  },
  switchContainer: {
    height: "40px",
    margin: 0,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    [theme.breakpoints.down("xs")]: {
      marginTop: theme.spacing(2),
    },
  },
  checkbox: {
    marginBottom: 0,
    display: "flex",
    alignItems: "center",
  },
  checkboxLabel: {
    textTransform: "none",
    color: "#73706E",
    fontWeight: "700",
  },
});

class Preferences extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedAllowMwsOrders: false,
      productIdentifier: "asin",
      performanceMetric: "acos",
      message: "",
      errorMessage: "",
      saveRedirect: false,
    };
    this.onSave = this.onSave.bind(this);
  }

  componentDidMount() {
    axios
      .get(URL_PREFIX + "/api/org_permissions/")
      .then((res) => {
        if (res.data) {
          if (res.data && "product_identifier" in res.data) {
            const productIdentifier = res.data["product_identifier"];

            this.setState({
              productIdentifier: productIdentifier,
            });
          }
          if (res.data && "preferences" in res.data) {
            const performanceMetric = res.data["preferences"]["acos_or_roas"];

            this.setState({
              performanceMetric: performanceMetric,
            });
          }
        } else {
          this.setState({
            message: "",
            errorMessage: "Failed loading permissions!",
          });
        }
      })
      .catch(() => {
        this.setState({
          message: "",
          errorMessage: "Failed loading permissions!",
        });
      });
  }

  async onSave() {
    this.setState({ message: "Saving permissions...", errorMessage: "" });

    const data = {
      product_identifier: this.state.productIdentifier,
      acos_or_roas: this.state.performanceMetric,
    };

    await axios
      .put(URL_PREFIX + "/api/org_permissions/", data)
      .then(() => {
        store.dispatch(setProductIndentifier(this.state.productIdentifier));
        store.dispatch(setPerformanceMetric(this.state.performanceMetric));

        successToast({
          message: "Saved your preferences.",
        });
        this.setState(
          {
            message: "Saved preferences",
            errorMessage: "",
            saveRedirect: true,
          },
          () =>
            setTimeout(() => {
              this.props.user.permissions === "reports" ?
                this.props.history.push("/user/report/advertisement")
              : this.props.history.push("/user/dashboard");
            }, 2000),
        );
      })
      .catch((error) => {
        errorToast({ message: "Failed to save your preferences, please retry.", error });
        this.setState({
          message: "",
          errorMessage: "Failed saving user preferences!",
        });
      });
  }

  render() {
    const { classes } = this.props;
    return (
      <PageContainer>
        <VStack
          maxWidth="1000px"
          alignItems={"stretch"}
          width="100%"
          paddingX="xxlarge"
          paddingY="large"
          alignSelf={"center"}
        >
          <h4
            className={css({
              margin: 0,
              fontWeight: "bold",
              textAlign: "center",
            })}
          >
            Preferences
          </h4>
          <Card>
            <div style={{ width: "100%" }}>
              <div>
                <Grid container className={classes.preferenceContainer}>
                  <Grid item xs={12}>
                    <h5 className={classes.preferenceTitle}>Products</h5>
                  </Grid>
                </Grid>
                {this.props.channel?.currentChannel !== "walmart" && (
                  <Grid container>
                    <Grid item xs={12} sm={8} className={classes.preferenceDescriptionContainer}>
                      <div className={classes.preferenceDescription}>Select your preferred product identifier</div>
                    </Grid>
                    <Grid item xs={6} sm={2} className={classes.checkboxContainer}>
                      <div className={`checkbox checkbox-inline ${classes.checkbox}`}>
                        <h5 className={`title ${classes.checkboxLabel}`}>
                          <input
                            id={40}
                            type="checkbox"
                            onClick={() => {
                              this.setState({
                                sku: true,
                                asin: false,
                                productIdentifier: "sku",
                              });
                            }}
                            checked={this.state.productIdentifier === "sku"}
                          />
                          <label htmlFor={40}>{"SKU"}</label>
                        </h5>
                      </div>
                    </Grid>
                    <Grid item xs={6} sm={2} className={classes.checkboxContainer}>
                      <div className={`checkbox checkbox-inline ${classes.checkbox}`}>
                        <h5 className={`title ${classes.checkboxLabel}`}>
                          <input
                            id={41}
                            type="checkbox"
                            onClick={() => {
                              this.setState({
                                asin: true,
                                sku: false,
                                productIdentifier: "asin",
                              });
                            }}
                            checked={this.state.productIdentifier === "asin"}
                          />
                          <label htmlFor={41}>{"ASIN"}</label>
                        </h5>
                      </div>
                    </Grid>
                  </Grid>
                )}
                <Grid container className={classes.preferenceContainer}>
                  <Grid item xs={12}>
                    <h5 className={classes.preferenceTitle}>Performance Metric</h5>
                  </Grid>
                </Grid>
                <Grid container>
                  <Grid item xs={12} sm={8} className={classes.preferenceDescriptionContainer}>
                    <div className={classes.preferenceDescription}>Select your preferred performance metric</div>
                  </Grid>
                  <Grid item xs={6} sm={2} className={classes.checkboxContainer}>
                    <div className={`checkbox checkbox-inline ${classes.checkbox}`}>
                      <h5 className={`title ${classes.checkboxLabel}`}>
                        <input
                          id={42}
                          type="checkbox"
                          onClick={() => {
                            this.setState({
                              acos: true,
                              roas: false,
                              performanceMetric: "acos",
                            });
                          }}
                          checked={this.state.performanceMetric === "acos"}
                        />
                        <label htmlFor={42}>{"ACOS"}</label>
                      </h5>
                    </div>
                  </Grid>
                  <Grid item xs={6} sm={2} className={classes.checkboxContainer}>
                    <div className={`checkbox checkbox-inline ${classes.checkbox}`}>
                      <h5 className={`title ${classes.checkboxLabel}`}>
                        <input
                          id={43}
                          type="checkbox"
                          onClick={() => {
                            this.setState({
                              acos: false,
                              roas: true,
                              performanceMetric: "roas",
                            });
                          }}
                          checked={this.state.performanceMetric === "roas"}
                        />
                        <label htmlFor={43}>{"ROAS"}</label>
                      </h5>
                    </div>
                  </Grid>
                </Grid>
              </div>
            </div>
            <Center>
              <Button variant="primary" onPress={() => this.onSave()} style={{ margin: "2rem auto" }}>
                Save
              </Button>
            </Center>
          </Card>
        </VStack>
      </PageContainer>
    );
  }
}

const mapStateToProps = (state) => ({
  auth: state.auth,
  user: state.user,
  errors: state.errors,
  modules: selectModules(state),
  channel: state.channel,
});

export default connect(mapStateToProps)(withRouter(withStyles(useStyles)(Preferences)));
